import {
    Grid,
    Label,
    Paragraph,
    useStyles,
    useAppDisplayModeContext,
    pxToRem,
} from '@archipro-design/aria';

import * as S from './SectionHeader.style';

import { NarrowContent } from '@modules/articles/component/page-layout/PageLayout.style';
import React from 'react';

interface SectionHeaderProp {
    title: string;
    content?: string;
}

const SectionHeader: React.FC<SectionHeaderProp> = ({ title, content }) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    const { css } = useStyles();

    return (
        <div className={css(S.Wrap)}>
            <Grid
                columns={isMobile ? 1 : `${pxToRem(720)} 1fr`}
                className={css(NarrowContent)}
            >
                <div className={css(S.ContentWrap)}>
                    {content && (
                        <Paragraph
                            className={css(S.ContentParagraph)}
                            dangerouslySetInnerHTML={{ __html: content }}
                        />
                    )}
                </div>

                <div className={css(S.Header)}>
                    <Label
                        variables={(siteVars) => ({
                            ...siteVars?.textStyles.Article.Roman55,
                            fontSize: pxToRem(40),
                            lineHeight: '100%',
                        })}
                    >
                        {title}
                    </Label>
                </div>
            </Grid>
        </div>
    );
};

export default SectionHeader;
